import { useState } from "react";
import axios from "axios";
import {useAuth} from "../../hook/useAuth";
import './style.css'
import { API_URL } from "../../hook/useChat";

const NewUser = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { user , setUser } = useAuth();

  const handleUser = async () => {
    if (!name || !email) {
      setError("Both fields are required.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(`${API_URL}/new_user`, { name, email , intent:"default" });
      setUser({name ,email})
      console.log("User created:", res.data);
    } catch (error) {
      setError("Failed to create user." , error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-conatiner">
      {user && (
        <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter Email"
        className="custom-input"
        required
      />
      )}
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Enter Name"
        className="custom-input"
      />
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter Email"
        className="custom-input"
        required
      />
      {error && <p className="err_msg">{error}</p>}
      <button
        type="button"
        onClick={handleUser}
        className="user_btn"
        disabled={loading}
      >
        {loading ? "Saving..." : "Save"}
      </button>
    </div>
  );
};

export default NewUser;